/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import CustomGridCellRendererComponent from '../../../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
import { currencyFormatter } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import { textCustomComparator } from '../../../../../contactType/components/tableHead';
import * as Styles from '../../../../../Maintain/client/Components/StyleConstant';

const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const QUARTERLY_MRKT_HEAD = [
  {
    headerName: 'Qtr',
    field: 'qtr',
    editable: false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    comparator: comparatorQtr,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Inv Amt',
    field: 'adjInvAmt',
    minWidth: 160,
    maxLength: Styles.Length_255,
    editable: false,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Payments',
    field: 'payments',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Pct p/a(%)',
    field: 'receiptsToAdjPct',
    editable: false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    excelAlignment: 'right',
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
  },
  {
    headerName: 'Tot Reimb',
    field: 'totalReimb',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Receipts to Reimb(%)',
    field: 'receiptsToReimbPct',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    editable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Orig To Reimb',
    field: 'origTotReimb',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Adj To Reimb',
    field: 'adjToReimb',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Orig Inv',
    field: 'origInv',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Pct p/o(%)',
    field: 'receiptsToOriginvPct',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
  },
  {
    headerName: 'HCPCS Current Inv Amt',
    field: 'hCPCSCURRENTINVAMT',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Estimated HCPCS Code Receipts',
    field: 'estHcpcsCodeReceipts',
    minWidth: 200,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'HCPCS Current Reimb',
    field: 'hCPCSCURRENTREIMB',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    isTextColorRed: true,
    filter: 'agTextColumnFilter',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'HCPCS Pct p/o(%)',
    field: 'estToCurrHcpcsPct',
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    cellStyle: { textAlign: 'right' },
    excelAlignment: 'right',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
  },
];
export const QUARTERLY_MRKT_SUP_HEAD = [
  {
    headerName: 'Qtr',
    field: 'qtr',
    minWidth: 160,
    maxLength: Styles.Length_255,
    comparator: comparatorQtr,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Inv Amt',
    field: 'adjInvAmt',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Payments',
    field: 'payments',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Pct p/a(%)',
    field: 'receiptsToAdjPct',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Tot Reimb',
    field: 'totalReimb',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Receipts to Reimb(%)',
    field: 'receiptsToReimbPct',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Orig To Reimb',
    field: 'origTotReimb',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj To Reimb',
    field: 'adjToReimb',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Orig Inv',
    field: 'origInv',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Pct p/o(%)',
    field: 'receiptsToOriginvPct',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { textAlign: 'right' },
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '',
    comparator: amountComparator,
    excelAlignment: 'right',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
